
export default function Overlay (props) {
	return (
		<div 
		//className={"overlay "  + (props.show ? "show" : "")}
		className="overlay"
		style={ props.show ? {display: 'block'} : {display: 'none'}}
		onClick={props.onClick}
		>
		</div>
	)
}